var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApiKeys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3669_29178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5338 11.2261L19.7599 2L21.422 3.66209L19.7599 5.32536L22.668 8.23343L21.0059 9.89669L18.0966 6.98745L16.4346 8.64954L18.9277 11.1427L17.2656 12.8059L14.7725 10.3116L12.1959 12.8882C12.9957 14.1036 13.3165 15.5725 13.0962 17.0107C12.8759 18.4489 12.1301 19.7543 11.0031 20.6746C9.87611 21.5948 8.44792 22.0645 6.9947 21.9929C5.54148 21.9212 4.16645 21.3132 3.13548 20.2865C2.10229 19.2572 1.4887 17.8805 1.41398 16.424C1.33925 14.9675 1.80872 13.5353 2.73114 12.4056C3.65356 11.276 4.96304 10.5296 6.40507 10.3116C7.84711 10.0936 9.31868 10.4196 10.5338 11.2261ZM9.78502 18.6233C10.1274 18.2994 10.4015 17.9101 10.5909 17.4785C10.7803 17.0469 10.8813 16.5817 10.8878 16.1104C10.8944 15.6391 10.8064 15.1713 10.629 14.7346C10.4517 14.2979 10.1886 13.9011 9.85532 13.5679C9.52203 13.2346 9.12531 12.9715 8.6886 12.7941C8.2519 12.6168 7.78407 12.5288 7.31278 12.5354C6.84148 12.5419 6.37628 12.6429 5.94467 12.8323C5.51307 13.0217 5.12381 13.2957 4.79992 13.6382C4.15757 14.3032 3.80213 15.194 3.81017 16.1186C3.8182 17.0432 4.18906 17.9277 4.84288 18.5815C5.49669 19.2353 6.38115 19.6062 7.30575 19.6142C8.23035 19.6222 9.12112 19.2668 9.78619 18.6244L9.78502 18.6233Z",
    fill: "#344054"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3669_29178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiKeys);
export default __webpack_public_path__ + "static/media/api_keys.13ea90ac.svg";
export { ForwardRef as ReactComponent };